const initialState = "";

const webTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_WEBTOKEN":
      return action.data;
    default:
      return state;
  }
};

export default webTokenReducer;
